/**
 * Whether this engine can play an adaptive stream at all.
 *
 * Its own module, holding no Shaka import, and that is the entire point: the answer is needed
 * **during render** (`useWatchScreen` derives the playback plan from it), so as long as it came from
 * `shaka.Player.isBrowserSupported()` the whole engine had to be in the initial chunk — about a
 * megabyte of it, parsed by every feed, search and settings page that can never play a video.
 * `loadShakaPlayer.ts` is the other half of that split.
 *
 * `ManagedMediaSource` counts: it is what an iPhone offers instead of `MediaSource`, and Shaka
 * streams over it. The question this answers is narrower than Shaka's own — that one also checks
 * EME and runs after `polyfill.installAll()` — so an engine that has a media source and that Shaka
 * would nonetheless decline now reaches the player and fails there. That is a state the watch screen
 * already renders (`player.md`'s failure grammar), and it is not a state any engine in use is in.
 */
export function isMseSupported(): boolean {
  return 'MediaSource' in globalThis || 'ManagedMediaSource' in globalThis;
}
